import React, { FunctionComponent } from "react";
import styled from "styled-components";

interface WrapperItemsProps {
  className?: string;
  children: React.ReactNode;
}

const WrapperItems: FunctionComponent<WrapperItemsProps> = ({
  className,
  children,
}) => {
  return <section className={className || ""}>{children}</section>;
};

export const HomeWrapperItems = styled(WrapperItems)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: visible;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.tablet}px`}) {
    .separator {
      margin-inline: 24px;
      width: calc(100% - (24px * 2));
    }
  }
`;
